module.exports = __webpack_public_path__ + "img/geometry.63254490.png";